import Companies from '@/api/companies'

export default {
  namespaced: true,
  state: {
    currentCompany: null,
    imageFile: null,
    name: '',
    domain: '',
    currentCompanyId: '',
    imageUrl: '',
    category: null,
    companyJobsBoard: [],
    inviteCompanyEmail: '',
    selectedJobBoard: '',
    bio: '',
    bioError: '',
    companyNameError: null,
    companyDomainError: null
  },
  mutations: {
    loadFromCompany (state, company) {
      state.imageUrl = company.imageUrl
      state.name = company.name
      state.domain = company.domain
      state.imageFile = null
      state.currentCompanyId = company.id
      state.category = company.category
      state.companyJobsBoard = company.hasOwnProperty('companyJobsBoard') ? company.companyJobsBoard : []
      state.bio = company.bio
    },
    clear (state) {
      state.imageFile = null
      state.name = ''
      state.domain = ''
      state.currentCompanyId = ''
      state.imageUrl = ''
      state.category = null
      state.inviteCompanyEmail = ''
      state.companyJobsBoard = []
      state.bio = ''
    },
    setCurrentCompany (state, company) {
      state.currentCompany = company
    },
    setCurrentCompanyId (state, companyId) {
      state.currentCompanyId = companyId
    },
    setImageFile (state, imageFile) {
      state.imageFile = imageFile
    },
    setName (state, name) {
      if (name.length > 0) {
        state.companyNameError = null
      }
      state.name = name
    },
    setDomain (state, domain) {
      if (domain.length > 0) {
        state.companyDomainError = null
      }
      state.domain = domain
    },
    setCategory (state, category) {
      state.category = category
    },
    setInviteCompanyEmail (state, email) {
      state.inviteCompanyEmail = email
    },
    setSelectedJobBoard (state, selectedJobBoard) {
      state.selectedJobBoard = selectedJobBoard
    },
    clearInviteCompanyForm (state) {
      state.inviteCompanyEmail = ''
      state.selectedJobBoard = ''
    },
    setCompanyJobBoard (state, companyJobsBoard) {
      state.companyJobsBoard = companyJobsBoard
    },
    setBio (state, bio) {
      if (bio.length > 0) {
        state.bioError = ''
      }
      state.bio = bio
    },
    setBioError (state, bioError) {
      state.bioError = bioError
    },
    setCompanyDomainError (state, companyDomainError) {
      state.companyDomainError = companyDomainError
    },
    setCompanyNameError (state, companyNameError) {
      state.companyNameError = companyNameError
    }
  },
  actions: {
    async setData ({ commit }, {bio, image, name, domain, category, companyJobsBoard}) {
      commit('setImageFile', image)
      commit('setName', name)
      commit('setDomain', domain)
      commit('setCategory', category)
      commit('setCategory', category)
      commit('setCompanyJobBoard', companyJobsBoard)
      commit('setBio', bio)
    },
    async createNewCompany ({ state, commit }) {
      const jobBoards = state.companyJobsBoard.map(item => item.id)
      const formData = {
        image: state.imageFile,
        name: state.name,
        domain: state.domain,
        category: state.category,
        companyJobsBoard: jobBoards,
        bio: state.bio
      }
      const company = await Companies.create(formData)
      commit('setCurrentCompany', company)
      commit('adminCompanies/addCompany', company, { root: true })
    },
    async inviteCompany ({ state, commit }) {
      await Companies.inviteCompany(state.selectedJobBoard, state.inviteCompanyEmail)
    },
    async updateCompany ({ state, commit }) {
      const jobBoards = state.companyJobsBoard.map(item => item.id)
      const formData = {
        name: state.name, domain: state.domain, company: state.currentCompany, companyJobsBoard: jobBoards, bio: state.bio
      }

      if (state.imageFile) {
        formData['image'] = state.imageFile
      }

      const company = await Companies.update(state.currentCompanyId, formData)
      commit('adminCompanies/updateCompany', company, { root: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company-form.js